// Footer.jsx

import "../styles/Footer.css";
import { FaInstagram } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { Link } from "react-router-dom";



export default function Footer({ backgroundColor = "transparent" }) {
  return (
    <footer className="footer" style={{ backgroundColor }}>
      <div className="footer-row">
        <div className="footer-left">
          <img
            src="/Assets/logo_hyve.png"
            alt="Logo Le Hyve"
            className="footer-logo"
          />
        </div>

        <div className="footer-center">
          <span className="footer-contact">
              <MdEmail /> 
            
             <Link to="/contact" className="footer-contact-link">
              Contactez-nous
            </Link>
          </span>
          <span className="footer-ig">
            <FaInstagram />             
              @lehyve.paris
          </span>
        </div>

        <div className="footer-links">
          <a href="/mentions-legales">Mentions légales</a>
          <a href="/politique-confidentialite">Politique de confidentialité</a>
        </div>
      </div>

      <div className="footer-copy">
        © Le Hyve. Tous droits réservés.
      </div>
    </footer>
  );
}